import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Error from "./AdminPanel/pages/Error/Error";
import AdminRouteApp from "./AdminPanel/Routes/AdminRouteApp";
import "./App.scss";
import CookieModal from "./common/CookieModal";
import Loader from "./common/Loader";
// import DashboardApp from "./User/components/dashboard/DashboardApp";
// import UserRouteApp from "./User/routes/UserRouteApp";
import adminAxiosInstance from "./config";
import TUBanner from "./common/TUBanner";
import Cookies from "js-cookie";
// import OrderCp from "./User/components/Home/pages/OrderCp";
function App() {
  // const [isAd, setIsAd] = useState(false);
  const adminToken = localStorage.getItem("token");

  // const fetchScript = async () => {
  //   try {
  //     const res = await adminAxiosInstance.get(
  //       "title/getAll?type=globalScriptTitle",
  //       {
  //         headers: { Authorization: `Bearer ${adminToken}` },
  //       }
  //     );
  //     console.log("res----->>", res);
  //     // setScriptData(res.data.data[0]);
  //     // res?.data?.data[0]?.head.forEach((e) => {
  //     //   var x = e.slice(8, e.length - 9);
  //     //   var script = document.createElement("script");
  //     //   script.append(x);
  //     //   document?.head?.prepend(script);
  //     // });
  //     // res?.data?.data[0]?.body.forEach((e) => {
  //     //   var x = e.slice(8, e.length - 9);
  //     //   var script = document.createElement("script");
  //     //   script.append(x);
  //     //   document?.body?.prepend(script);
  //     // });
  //   } catch (err) {
  //     // setScriptData("<script></script>");
  //   }
  // };

  // useEffect(() => {
  //   const cookies = Cookies.get("accept_cookie");
  //   // console.log("cookies",cookies)

  //   if (cookies === "true") {
  //     // console.log("sdfjsdfk",true)
  //     setTimeout(() => {
  //       setIsAd(true);
  //     }, 3000);
  //   }
  // }, []);

  // React.useEffect(() => {
  //   fetchScript();
  // }, []);
  return (
    <div className="app">
      {/* <CookieModal setIsAd={(value) => setIsAd(value)} /> */}
      {/* <TUBanner isActive={isAd} click={setIsAd} /> */}
      <BrowserRouter>
        {/* <Loader /> */}
        {/* {loading !== 100 && <Loader isVisable={loading} />} */}
        <Routes>
          {/* protected */}
          {/* <Route exact path="/*" element={<UserRouteApp />} /> */}
          <Route exact path="/admin/*" element={<AdminRouteApp />} />
          {/* <Route exact path="/dashboard/*" element={<DashboardApp />} /> */}
          {/* <Route exact path="/cp/*" element={<CpRoutes />} /> */}
          <Route exact path="*" element={<Error />} />
          {/* <Route path="/place:id" exact element={<OrderCp />}></Route> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
